module.exports = __webpack_public_path__ + "img/pt.c31a6c4.svg";